import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { createLogger } from 'redux-logger';

import Root from './app/root';
import appReducer from './app/reducer';

import './styles/kendo-imports.scss';
import './styles/main.scss';
import './styles/mobile.scss';

const middlewareArray = [thunkMiddleware];
if(process.env.NODE_ENV === 'development') {
    const loggerMiddleware = createLogger();
    middlewareArray.push(loggerMiddleware);
}

const storeEnhancer = applyMiddleware(...middlewareArray);
const store = createStore(appReducer, storeEnhancer);

ReactDOM.render(
    <Root store={store} />, 
    document.getElementById('root')
);